import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MutasiAntarCounterFormPageRoutingModule } from './mutasi-antar-counter-form-routing.module';

import { MutasiAntarCounterFormPage } from './mutasi-antar-counter-form.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    IonicSelectableModule,
    MutasiAntarCounterFormPageRoutingModule,
  ],
  declarations: [MutasiAntarCounterFormPage]
})
export class MutasiAntarCounterFormPageModule {}
